import { Vector2 } from "three";
import { UIInteractionEvent } from "../../../library-js/dom-ui/interactions/UIInteractionEvent";
import { NodeGraph } from "../model/NodeGraph";
import { NodeGraphComponent } from "../model/NodeGraphComponent";
import { NodeGraphReference } from "../model/NodeGraphReference";

export class ElementWithNodeGraphReference
{
  element:Element;
  reference:NodeGraphReference;
}

export class NodeGraphEvent extends UIInteractionEvent
{ 
  _nodeGraph:NodeGraph;

  constructor( ng:NodeGraph )
  {
    super();
    this._nodeGraph = ng;
  }

  get hoveredReference():ElementWithNodeGraphReference
  {
    let hovered = this.hoveredElement;
    
    if ( ! hovered )
    {
      return null;
    }
    
    let reference = NodeGraphReference.findReference( hovered, this._nodeGraph );

    if ( ! reference )
    {
      return null;
    }


    let result = new ElementWithNodeGraphReference();

    result.element = hovered;
    result.reference = reference;

    return result;

  }

}